import { Component, Inject, OnInit } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MatSnackBar } from '@angular/material/snack-bar';
import { StorageDataService } from '@ecap3/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DocumentManagerService } from 'src/app/business/app-platform-document-manager';

export interface Document {
    FileId: string;
    Title: string;
    DateOfIssue: string | null;
    ExpiryDate: string | null;
    Source: string;
    Type: string;
    Url: string | null;
}

@Component({
    selector: 'app-announcement-bottomsheet',
    templateUrl: './announcement-bottomsheet.component.html',
    styleUrls: ['./announcement-bottomsheet.component.scss']
})
export class AnnouncementBottomsheetComponent implements OnInit {
    private _unsubscribeAll: Subject<any>;

    constructor(
        @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
        private _bottomSheetRef: MatBottomSheetRef<AnnouncementBottomsheetComponent>,
        private documentManagerService: DocumentManagerService,
        private storageDataService: StorageDataService,
        private matSnackBar: MatSnackBar,
    ) {
        this._unsubscribeAll = new Subject();
    }

    ngOnInit() {
        console.log(this.data);
    }

    closeBottomSheet() {
        this._bottomSheetRef.dismiss();
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null as any);
        this._unsubscribeAll.complete();
    }

    preview(document: Document): void {
        if (!document || !document.FileId) {
            console.error('Invalid document or FileId');
            return;
        }

        this.documentManagerService.changeworkingState('busy');
        this.storageDataService.getFilesInfo([document.FileId])
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe({
                next: (res) => {
                    const file = res.body[0];
                    const fileUrl = file.Url || '';
                    const isMicrosoftFileType = this.isMicrosoftFileType(file.Name);
                    this.documentManagerService.changeworkingState('idle');

                    if (isMicrosoftFileType) {
                        const embededUrl = this.embedUrlWithOfficeLive(fileUrl);
                        window.open(embededUrl);
                    } else if (this.isPDF(file.Name)) {
                        const viewerUrl = `https://docs.google.com/viewer?url=${encodeURIComponent(fileUrl)}&embedded=true`;
                        window.open(viewerUrl, '_blank');
                    } else {
                        window.open(fileUrl);
                    }
                }
            });
    }

    download(document: Document): void {
        if (!document || !document.FileId) {
            this.matSnackBar.open('Invalid document or FileId', 'Close', { duration: 3000 });
            return;
        }

        this.documentManagerService.downloadDocumentFile(document.FileId)
            .then(result => {
                if (result.Status) {
                    this.matSnackBar.open('Download successful', 'Close', { duration: 3000 });
                } else {
                    this.matSnackBar.open('Download failed', 'Close', { duration: 3000 });
                }
            })
            .catch(() => {
                this.matSnackBar.open('Download failed', 'Close', { duration: 3000 });
            });
    }


    embedUrlWithOfficeLive(url: string): string {
        let viewerUrl = `https://view.officeapps.live.com/op/embed.aspx?src=%URL%`;

        const u = url.indexOf('/') ? encodeURIComponent(url) : url;
        let fullUrl = viewerUrl ? viewerUrl.replace('%URL%', u) : url;

        return fullUrl;
    }


    private isMicrosoftFileType(fileName: string): boolean {
        const fileType = fileName.split('.').pop();
        const microsoftFileTypes = ['doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx'];
        const index = microsoftFileTypes.indexOf(fileType);
        if (index < 0) return false;

        return true;

    }
    private isPDF(fileName: string): boolean {
        const fileType = fileName.split('.').pop();
        return fileType === 'pdf'
    }
}
